import { Box, Tooltip, Typography, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
// import originalConfig from "./../enrollSubject/subjectEnrolForms.json";
// import originalConfig from './../enrollSubject/vir_subject_enrollment_forms.json';
import {
  bloqcibeApi,
  useExternalVerifySubjectMutation,
  useGetSubjectAnswersQuery,
  useGetTrialDetailsQuery,
  useGetTrialSiteInfoQuery,
} from '../../store/slices/apiSlice';
import { findObjectByKey, getUserRole } from '../util';
import { forwardRef, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import _ from 'lodash';
import { base64ToArrayBuffer } from '../../components/common/DocumentUpload';
import { deliverDownloadedFile } from '../../util/filePreviewUtils';
import { useSpring, animated } from '@react-spring/web';
import SvgIcon from '@mui/material/SvgIcon';
import Collapse from '@mui/material/Collapse';
import { alpha, styled } from '@mui/material/styles';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem, treeItemClasses } from '@mui/x-tree-view/TreeItem';
import FormDetails from './subjectDetailCRF/FormDetails';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import { openMessage } from '../../store/slices/showMessageSlice';
import { setUserLocation } from '../../store/slices/userDetailsSlice';
import { createNewFields } from '../util';
import { setQueries, setQueriesLoading, clearQueries, selectHasOpenQueries, selectQueriesByFieldKey, selectRefetchTrigger } from '../../store/slices/querySlice';

function MinusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14, color: '#FF6602' }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 11.023h-11.826q-.375 0-.669.281t-.294.682v0q0 .401.294 .682t.669.281h11.826q.375 0 .669-.281t.294-.682v0q0-.401-.294-.682t-.669-.281z" />
    </SvgIcon>
  );
}
function PlusSquare(props) {
  return (
    <SvgIcon fontSize="inherit" style={{ width: 14, height: 14, color: '#FF6602' }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0zM17.873 12.977h-4.923v4.896q0 .401-.281.682t-.682.281v0q-.375 0-.669-.281t-.294-.682v-4.896h-4.923q-.401 0-.682-.294t-.281-.669v0q0-.401.281-.682t.682-.281h4.923v-4.896q0-.401.294-.682t.669-.281v0q.401 0 .682.281t.281.682v4.896h4.923q.401 0 .682.281t.281.682v0q0 .375-.281.669t-.682.294z" />
    </SvgIcon>
  );
}

function CloseSquare(props) {
  return (
    <SvgIcon className="close" fontSize="inherit" style={{ width: 14, height: 14 }} {...props}>
      {/* tslint:disable-next-line: max-line-length */}
      <path d="M17.485 17.512q-.281.281-.682.281t-.696-.268l-4.12-4.147-4.12 4.147q-.294.268-.696.268t-.682-.281-.281-.682.294-.669l4.12-4.147-4.12-4.147q-.294-.268-.294-.669t.281-.682.682-.281.696 .268l4.12 4.147 4.12-4.147q.294-.268.696-.268t.682.281 .281.669-.294.682l-4.12 4.147 4.12 4.147q.294.268 .294.669t-.281.682zM22.047 22.074v0 0-20.147 0h-20.12v0 20.147 0h20.12zM22.047 24h-20.12q-.803 0-1.365-.562t-.562-1.365v-20.147q0-.776.562-1.351t1.365-.575h20.147q.776 0 1.351.575t.575 1.351v20.147q0 .803-.575 1.365t-1.378.562v0z" />
    </SvgIcon>
  );
}

function TransitionComponent(props) {
  const style = useSpring({
    to: {
      opacity: props.in ? 1 : 0,
      transform: `translate3d(${props.in ? 0 : 20}px,0,0)`,
    },
  });

  return (
    <animated.div style={style}>
      <Collapse {...props} />
    </animated.div>
  );
}

const CustomTreeItem = forwardRef((props, ref) => (
  <TreeItem {...props} TransitionComponent={TransitionComponent} ref={ref} />
));

const StyledTreeItem = styled(CustomTreeItem)(({ theme, selected }) => ({
  [`& .${treeItemClasses.iconContainer}`]: {
    '& .close': {
      opacity: 0.3,
    },
  },
  [`& .${treeItemClasses.group}`]: {
    marginLeft: 15,
    paddingLeft: 18,
    borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
  },
  [`& .${treeItemClasses.content}`]: {
    backgroundColor: selected ? alpha(theme.palette.primary.main, 0.08) : 'transparent',
    '&:hover': {
      backgroundColor: selected ? alpha(theme.palette.primary.main, 0.12) : alpha(theme.palette.action.hover, 0.08),
    },
    '&.Mui-selected': {
      backgroundColor: alpha(theme.palette.primary.main, 0.16),
      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.2),
      },
    },
  },
}));

const SubjectDetailCRFInfo = (props) => {
  const { state } = useLocation();
  const { stepStatusData, subjectName, subjectDetailWithSteps } = props;
  const crfDocumentKey = useSelector((state) => state?.trial?.trialSiteDetail?.siteTrialData?.trial?.crfForm);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const { trialId, siteId, trialSiteId, subjectMasterId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [originalFormConfig, setOriginalFormConfig] = useState(null);
  // const [originalFormConfig, setOriginalFormConfig] = useState(originalConfig);
  const sponsorId = useSelector((state) => state.auth.sponsorId);
  const [selectedForm, setSelectedForm] = useState(); 
  const [selectedStepKey, setSelectedStepKey] = useState();
  const [getLibraryForm] = bloqcibeApi.endpoints.getLibraryForm.useLazyQuery();
  const customFieldsProcessedRef = useRef(false);
  const [formConfigLoaded, setFormConfigLoaded] = useState(false);
  const [expandedNodes, setExpandedNodes] = useState([]);
  const [selectedNodeId, setSelectedNodeId] = useState(null);

  //START USING V2 API
  const { data: trialDetails } = useGetTrialDetailsQuery({
    id: trialId,
    sponsorId: sponsorId,
  });
  const [externalVerifySubject] = useExternalVerifySubjectMutation();
  const [downloadSubjectFile] = bloqcibeApi.endpoints.downloadSubjectFile.useLazyQuery();
  const { user: loggedInUser, userData } = useSelector((state) => state.auth);
  const [formConfig, setFormConfig] = useState(null);
  // const [userSiteTrialRole, setUserSiteTrialRole] = useState("");
  // const [formConfig, setFormConfig] = useState(originalConfig);

  const [manualSelection, setManualSelection] = useState(false);
  const [downloadSubjectSignature] = bloqcibeApi.endpoints.downloadSubjectSignature.useLazyQuery();
  const [getSubjectAnswers, { data: subjectDetails }] = bloqcibeApi.endpoints.getSubjectAnswers.useLazyQuery();
  const [getQueries] = bloqcibeApi.endpoints.getQueries.useLazyQuery();
  
  // Query selectors from Redux
  const hasOpenQueries = useSelector(selectHasOpenQueries);
  const queriesByFieldKey = useSelector(selectQueriesByFieldKey);
  const refetchTrigger = useSelector(selectRefetchTrigger);
  const { data: trialSiteData } = useGetTrialSiteInfoQuery({
    sponsorId: sponsorId,
    trialId: trialId,
    siteTrialId: trialSiteId,
  });
  const { locationLat, locationLng } = useSelector((state) => state.userDetails);
  const enrolmentDocumentKey = useSelector(
    (state) => state?.trial?.trialSiteDetail?.siteTrialData?.trial?.eConsentForm
  );
  // State for notification focused field
  const [selectedfield, setSelectedField] = useState(null);

  const userSiteTrialRole = useMemo(() => {
    return getUserRole(loggedInUser, trialId, trialSiteData?.siteTrialData?.site?.id, userData);
  }, [loggedInUser, trialSiteData, userData]);

  // Function to extract custom fields from answers and merge them into form config
  const extractCustomFieldsFromAnswers = (formConfig, answers) => {
    if (!formConfig || !answers) return formConfig;

    try {
      const updatedConfig = JSON.parse(JSON.stringify(formConfig));
      let hasCustomFields = false;

      // Helper function to find and update categories with custom fields
      const updateCategoriesWithCustomFields = (steps) => {
        steps.forEach((step) => {
          step.sections?.forEach((section) => {
            section.categories?.forEach((category) => {
              // Check if category has addNew: true and addFields
              if (category.addNew && category.addFields && Array.isArray(category.addFields)) {
                // console.log(`Found category with addNew: ${category.key}`, category.addFields);
                const customFieldKeys = [];

                // Look for answers that match the pattern of custom fields
                // We need to check both direct answers and nested answers within categories
                const searchInAnswers = (answerObj, prefix = '') => {
                  if (!answerObj || typeof answerObj !== 'object') return;

                  Object.keys(answerObj).forEach((answerKey) => {
                    try {
                      const fullKey = prefix ? `${prefix}.${answerKey}` : answerKey;

                      // Check if this answer key corresponds to a custom field
                      category.addFields.forEach((templateField) => {
                        if (templateField && templateField.key && answerKey.startsWith(templateField.key + '-')) {
                          if (!customFieldKeys.includes(answerKey)) {
                            customFieldKeys.push(answerKey);
                          }
                        }
                      });

                      // Recursively search nested objects
                      if (typeof answerObj[answerKey] === 'object' && answerObj[answerKey] !== null) {
                        searchInAnswers(answerObj[answerKey], fullKey);
                      }
                    } catch (error) {
                      console.error('Error processing answer key:', answerKey, error);
                    }
                  });
                };

                searchInAnswers(answers);

                // If we found custom field answers, create the fields
                if (customFieldKeys.length > 0) {
                  const customFields = [];
                  customFieldKeys.forEach((fieldKey, index) => {
                    try {
                      // Find the template field that matches this custom field
                      const templateField = category.addFields.find(
                        (tf) => tf && tf.key && fieldKey.startsWith(tf.key + '-')
                      );

                      if (templateField) {
                        // Create a new field based on the template
                        const newField = JSON.parse(JSON.stringify(templateField));
                        newField.key = fieldKey;

                        // Update dependent field references
                        if (newField.dependsOn) {
                          newField.dependsOn = newField.dependsOn.replace(templateField.key, fieldKey);
                        }
                        if (newField.requiredDepends) {
                          newField.requiredDepends = newField.requiredDepends.replace(templateField.key, fieldKey);
                        }
                        if (newField.disabledDepends) {
                          newField.disabledDepends = newField.disabledDepends.replace(templateField.key, fieldKey);
                        }

                        // Recursively update nested fields
                        if (newField.fields && newField.fields.length > 0) {
                          newField.fields = createNewFields(newField.fields, index + 1);
                        }

                        customFields.push(newField);
                      }
                    } catch (error) {
                      console.error('Error creating custom field for key:', fieldKey, error);
                    }
                  });

                  // Add custom fields to the category
                  if (customFields.length > 0) {
                    console.log(
                      `Adding ${customFields.length} custom fields to category ${category.key}:`,
                      customFields
                    );
                    category.fields = [...(category.fields || []), ...customFields];
                    hasCustomFields = true;
                  }
                }
              }
            });
          });
        });
      };

      updateCategoriesWithCustomFields(updatedConfig.steps);

      if (hasCustomFields) {
        console.log('Custom fields were added to the form configuration');
      } else {
        console.log('No custom fields found in answers');
      }

      return updatedConfig;
    } catch (error) {
      console.error('Error extracting custom fields from answers:', error);
      return formConfig; // Return original config if there's an error
    }
  };

  useEffect(() => {
    (async () => {
      if (enrolmentDocumentKey) {
        setFormConfigLoaded(false);
        const _formDetailsData = await getLibraryForm(
          `${process.env.REACT_APP_API_ENDPOINT_URL}form-library/library/bloqcube/${enrolmentDocumentKey}`
          // `http://localhost:3003/form-library/library/bloqcube/${enrolmentDocumentKey}`
        );
        if (_formDetailsData.data) {
          setOriginalFormConfig(_formDetailsData.data);
          // Reset custom fields processing flag when form config changes
          customFieldsProcessedRef.current = false;
          setFormConfigLoaded(true);
        } else if (_formDetailsData.error) {
          console.error('UNABLE TO GET FORM DETAILS');
          setFormConfigLoaded(true); // Set to true even on error to allow fallback
        }
        // Set the original form config directly without custom field merging
        // setFormConfig(_formDetailsData.data);
      }
    })();
  }, [dispatch, enrolmentDocumentKey]);

  useEffect(() => {
    (async () => {
      await getSubjectAnswers({
        sponsorId,
        trialId,
        siteId,
        payload: {
          subjectMasterId: subjectMasterId,
          stepKey: selectedStepKey,
          sectionKey: selectedForm?.key,
          // subSectionKey: state?.subSectionKey,
        },
      });
      // Reset custom fields processing flag when subject changes
      customFieldsProcessedRef.current = false;
    })();
  }, [stepStatusData, subjectMasterId, selectedStepKey, selectedForm?.key]);

  // Fetch queries for the selected form
  useEffect(() => {
    const fetchQueries = async () => {
      if (!sponsorId || !trialId || !siteId || !subjectMasterId || !selectedStepKey || !selectedForm?.key) {
        return;
      }
      
      dispatch(setQueriesLoading(true));
      try {
        const result = await getQueries({
          sponsorId,
          trialId,
          siteId,
          stepKey: selectedStepKey,
          sectionKey: selectedForm?.key,
          subjectMasterId,
          page: 1,
          limit: 100,
          active: true,
        });

        if (result.data) {
          const fetchedQueries = result.data.data || [];
          dispatch(setQueries(fetchedQueries));
        } else {
          dispatch(setQueries([]));
        }
      } catch (error) {
        console.error('Error fetching queries:', error);
        dispatch(setQueries([]));
      }
    };

    fetchQueries();
    
    // Cleanup queries when component unmounts or form changes
    return () => {
      // Don't clear on every change, only on unmount
    };
  }, [sponsorId, trialId, siteId, subjectMasterId, selectedStepKey, selectedForm?.key, dispatch, getQueries, refetchTrigger]);

  // Clear queries when component unmounts
  useEffect(() => {
    return () => {
      dispatch(clearQueries());
    };
  }, [dispatch]);

  // Process form configuration with custom fields when both form config and answers are available
  useEffect(() => {
    if (originalFormConfig && subjectDetails && !customFieldsProcessedRef.current) {

      const updatedConfig = extractCustomFieldsFromAnswers(originalFormConfig, subjectDetails);

      setFormConfig(updatedConfig);
      customFieldsProcessedRef.current = true;
    }
  }, [originalFormConfig, subjectDetails]);

  useEffect(() => {
    if (!formConfig || manualSelection || !formConfigLoaded) return;

    // Read from URL query params first, then fallback to state or defaults
    const queryStepKey = searchParams.get('stepKey');
    const querySectionKey = searchParams.get('sectionKey');
    const querySubSectionKey = searchParams.get('subSectionKey');
    const queryFieldKey = searchParams.get('fieldKey');

    let selectedStep;
    let selectedSection;

    if (queryStepKey && querySectionKey) {
      // Use query params if available
      selectedStep = formConfig.steps.find((step) => step.key === queryStepKey);
      if (selectedStep) {
        selectedSection = selectedStep.sections.find((section) => section.key === querySectionKey);
        if (selectedSection && querySubSectionKey && selectedSection.subTabs) {
          const selectedSubSection = selectedSection.subTabs.find((subTab) => subTab.key === querySubSectionKey);
          if (selectedSubSection) {
            setSelectedForm(selectedSubSection);
          } else {
            setSelectedForm(selectedSection);
          }
        } else {
          setSelectedForm(selectedSection);
        }
        setSelectedStepKey(selectedStep.key);
        if (queryFieldKey) setSelectedField(queryFieldKey);

        // Set expanded nodes and selected node
        setExpandedNodes([queryStepKey]);
        setSelectedNodeId(`${querySectionKey}@${queryStepKey}`);
      }
    } else {
      // Fallback to existing logic
      selectedStep = formConfig.steps.find((step) => step.key === (state?.stepKey || formConfig.steps[0]?.key));
      selectedSection = selectedStep.sections.find(
        (section) => section.key === (state?.sectionKey || selectedStep.sections[0]?.key)
      );

      if (state?.fieldKey) setSelectedField(state.fieldKey);
      setSelectedStepKey(selectedStep.key);
      setSelectedForm(selectedSection);

      // Set expanded nodes and selected node
      setExpandedNodes([selectedStep.key]);
      setSelectedNodeId(`${selectedSection.key}@${selectedStep.key}`);

      // Update URL with initial selection
      const params = new URLSearchParams();
      params.set('stepKey', selectedStep.key);
      params.set('sectionKey', selectedSection.key);
      if (state?.fieldKey) params.set('fieldKey', state.fieldKey);
      setSearchParams(params, { replace: true });

      if (userSiteTrialRole === 'site_monitor' && stepStatusData) {
        const pendingVerificationStep = stepStatusData.find((step) => step.status === 'External_Verification_Pending');
        if (pendingVerificationStep) {
          const pendingVerificationStepConfig = formConfig.steps.find(
            (step) => step.key === pendingVerificationStep.stepKey
          );
          const pendingVerificationSection = pendingVerificationStep.sectionStatuses?.find(
            (section) => section.status === 'External_Verification_Pending'
          );
          const pendingVerificationSectionConfig = pendingVerificationStepConfig.sections.find(
            (section) => section.key === pendingVerificationSection?.sectionKey
          );

          const params = new URLSearchParams();
          params.set('stepKey', pendingVerificationStepConfig.key);
          params.set(
            'sectionKey',
            pendingVerificationSectionConfig?.key || pendingVerificationStepConfig.sections[0].key
          );
          setSearchParams(params, { replace: true });

          setSelectedStepKey(pendingVerificationStepConfig.key);
          setSelectedForm(pendingVerificationSectionConfig || pendingVerificationStepConfig.sections[0]);

          // Set expanded nodes and selected node
          setExpandedNodes([pendingVerificationStepConfig.key]);
          setSelectedNodeId(
            `${pendingVerificationSectionConfig?.key || pendingVerificationStepConfig.sections[0].key}@${
              pendingVerificationStepConfig.key
            }`
          );
        }
      }
    }
  }, [formConfig, state, stepStatusData, userSiteTrialRole, formConfigLoaded, searchParams, setSearchParams]);

  const editAllowed = useMemo(() => {
    const _stepStatusData = stepStatusData.find((_obj) => _obj.stepKey === selectedStepKey);
    const stepConfig = formConfig
      ? formConfig?.steps.find((step) => step.key === selectedStepKey)
      : null;

    // Subject is On_Hold - no edit allowed
    if (subjectDetailWithSteps && subjectDetailWithSteps?.status === 'On_Hold') {
      return false;
    }

    // Block editing for terminal statuses
    if (
      _stepStatusData &&
      ['Withdrawal', 'Enrollment_Failure', 'Screening_Failure', 'On_Hold'].includes(_stepStatusData.status)
    ) {
      return false;
    }

    if (userSiteTrialRole && _stepStatusData && _stepStatusData.userAccess) {
      const userAccess = JSON.parse(_stepStatusData.userAccess);
      const editAccess = userAccess.edit;
      const isAccess =
        typeof editAccess !== 'string'
          ? _.find(editAccess, (access) => {
              return access === userSiteTrialRole;
            })
          : editAccess === userSiteTrialRole;

      // Check readOnlyEdit configuration from step config
      // This allows role-based editing for specific form statuses
      const readOnlyEditConfig = stepConfig?.readOnlyEdit;

      // Allow edit if user has edit access
      if (isAccess && !readOnlyEditConfig) {
        return true;
      }

      if (readOnlyEditConfig) {
        const currentStatus = _stepStatusData.status;

        // Check granular status-based role access
        // Format: { "statusAccess": { "Pending": ["PI"], "Completed": ["site_monitor"] } }
        if (readOnlyEditConfig.statusAccess && readOnlyEditConfig.statusAccess[currentStatus]) {
          const statusRoles = readOnlyEditConfig.statusAccess[currentStatus];
          const hasStatusAccess = Array.isArray(statusRoles)
            ? statusRoles.includes(userSiteTrialRole)
            : statusRoles === userSiteTrialRole;

          if (hasStatusAccess) {
            return true;
          }
        }

        // Check legacy format: allowApplicableStatus + roles
        // Format: { "allowApplicableStatus": ["Pending"], "roles": ["PI", "site_coordinator"] }
        const allowApplicableStatus = readOnlyEditConfig.allowApplicableStatus || [];
        const readOnlyEditRoles = readOnlyEditConfig.roles || readOnlyEditConfig.access?.edit || [];

        if (allowApplicableStatus.length > 0) {
          const isStatusAllowed = allowApplicableStatus.includes(currentStatus);
          const hasReadOnlyEditAccess = Array.isArray(readOnlyEditRoles)
            ? readOnlyEditRoles.includes(userSiteTrialRole)
            : readOnlyEditRoles === userSiteTrialRole;

          if (isStatusAllowed && hasReadOnlyEditAccess) {
            return true;
          }
        }
      }

      // Allow edit if there are open queries on the form (for resolving queries)
      if (hasOpenQueries) {
        const currentStatus = _stepStatusData.status;
        const verifyAccess = userAccess.verify;
        const hasVerifyAccess = _.find(verifyAccess, (access) => access === userSiteTrialRole);

        // Allow editing for users with verify access when there are open queries
        if (hasVerifyAccess) {
          return true;
        }

        // Check readOnlyEdit for open queries - use queryResolutionAccess or statusAccess
        if (readOnlyEditConfig) {
          // Specific query resolution roles
          // Format: { "queryResolutionAccess": ["PI", "site_coordinator", "site_monitor"] }
          if (readOnlyEditConfig.queryResolutionAccess) {
            const queryRoles = readOnlyEditConfig.queryResolutionAccess;
            const hasQueryAccess = Array.isArray(queryRoles)
              ? queryRoles.includes(userSiteTrialRole)
              : queryRoles === userSiteTrialRole;

            if (hasQueryAccess) {
              return true;
            }
          }

          // Check if user has access for current status via statusAccess
          if (readOnlyEditConfig.statusAccess && readOnlyEditConfig.statusAccess[currentStatus]) {
            const statusRoles = readOnlyEditConfig.statusAccess[currentStatus];
            const hasStatusAccess = Array.isArray(statusRoles)
              ? statusRoles.includes(userSiteTrialRole)
              : statusRoles === userSiteTrialRole;

            if (hasStatusAccess) {
              return true;
            }
          }

          // Fallback to legacy roles
          const readOnlyEditRoles = readOnlyEditConfig.roles || readOnlyEditConfig.access?.edit || [];
          const hasReadOnlyEditAccess = Array.isArray(readOnlyEditRoles)
            ? readOnlyEditRoles.includes(userSiteTrialRole)
            : readOnlyEditRoles === userSiteTrialRole;

          if (hasReadOnlyEditAccess) {
            return true;
          }
        }
      }

      return false;
    }
    return false;
  }, [selectedStepKey, userSiteTrialRole, stepStatusData, subjectDetailWithSteps, hasOpenQueries, formConfig]);

  const openStepForm = (stepKey) => {
    navigate(
      `/eConcent/${trialId}/trial-site/${trialSiteId}/${selectedStepKey}/${subjectMasterId}?sectionKey=${stepKey}`
    );
  };

  const handleDownloadSignature = useCallback(async (s3Key, setSign) => {
    try {
      const result = await downloadSubjectSignature({
        sponsorId,
        trialId,
        siteId,
        subjectMasterId,
        s3Key: s3Key,
      });
      if (result.data) {
        const byteArray = base64ToArrayBuffer(result.data);
        const rr = new Blob([byteArray], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(rr);
        reader.onloadend = function () {
          const base64data = reader.result;
          setSign(base64data);
        };
        reader.onerror = function () {
          console.log('Failed to read signature data');
          setSign(null); // Call callback with null to reset loading state
        };
      } else {
        console.log('Failed to load signature');
        setSign(null); // Call callback with null to reset loading state
      }
    } catch (error) {
      console.error('Error downloading signature:', error);
      setSign(null); // Call callback with null to reset loading state
    }
  }, [downloadSubjectSignature]);
  function findObjectByValue(obj, targetValue, path = []) {
    for (const key in obj) {
      if (obj[key] === targetValue) {
        return obj;
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        // Continue searching in the nested object
        const result = findObjectByValue(obj[key], targetValue, [...path, key]);
        if (result) {
          return result;
        }
      }
    }
    // Value not found in the current object
    return null;
  }
  const onFormSelect = (e, node) => {
    const parts = node.split('@');
    const sectionKey = parts[0];
    const stepKey = parts[1];
    const _sec = findObjectByValue(formConfig, sectionKey);
    if (_sec && !_sec.subTabs && !_sec.sections) {
      setManualSelection(true);
      setSelectedStepKey(stepKey);
      setSelectedForm(_sec);

      // Update expanded nodes and selected node
      setExpandedNodes([stepKey]);
      setSelectedNodeId(`${sectionKey}@${stepKey}`);

      // Update URL query params
      const params = new URLSearchParams(searchParams);
      params.set('stepKey', stepKey);
      params.set('sectionKey', sectionKey);
      // Remove subSectionKey and fieldKey when selecting a new section
      params.delete('subSectionKey');
      params.delete('fieldKey');
      params.delete('tab');
      setSearchParams(params, { replace: true });
    }
  };
  const handleDownloadFile = async (s3Key, fileName, onBlob, options = {}) => {
    const result = await downloadSubjectFile({
      sponsorId,
      trialId,
      siteId,
      subjectMasterId,
      s3Key: s3Key,
    });
    if (result.data) {
      deliverDownloadedFile(result.data, fileName, onBlob, options);
    } else {
      onBlob && onBlob(null);
      console.log('Failed to load file');
    }
  };

  const selectedFormStatus = useMemo(() => {
    if (selectedStepKey && stepStatusData) {
      let statusData = findObjectByValue(stepStatusData, selectedStepKey);
      return statusData?.status;
    }
    return null;
  }, [stepStatusData, selectedStepKey]);

  const readOnlyActions = useMemo(() => {
    if (formConfig) {
      let step = formConfig.steps.find((step) => step.key === selectedStepKey);
      return step?.readOnlyActions;
    }
  }, [selectedStepKey, formConfig]);

  const getGeoLocation = async () => {
    // Geolocation is optional. We try to fetch it, but verification
    // should still proceed even if location is unavailable.
    if ('geolocation' in navigator) {
      return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            console.log(`Latitude: ${latitude}, Longitude: ${longitude}`);
            if (latitude && longitude) {
              dispatch(
                setUserLocation({
                  locationLatitude: latitude,
                  locationLongitude: longitude,
                })
              );
              resolve({ latitude, longitude });
            } else {
              resolve({ latitude: 0.0, longitude: 0.0 });
            }
          },
          (error) => {
            console.warn(`Error getting geolocation (continuing without it): ${error.message}`);
            // Optional: show a non-blocking warning instead of an error
            // dispatch(
            //   openMessage({
            //     message: 'Unable to access location. Continuing without location data.',
            //     messageSeverity: 'warning',
            //   })
            // );
            resolve({ latitude: 0.0, longitude: 0.0 });
          }
        );
      });
    } else {
      console.log('Geolocation is not supported. Continuing without location data.');
      return { latitude: 0.0, longitude: 0.0 };
    }
  };

  const handleSubjectVerification = async (payload) => {
    let _ans = {};
    if (selectedForm) {
      selectedForm?.categories &&
        selectedForm?.categories.forEach((category) => {
          const _answers = findObjectByKey(payload?.answers, category.key);
          if (_answers) _ans[category.key] = _answers;
        });
      selectedForm?.fields &&
        selectedForm?.fields.forEach((field) => {
          const _answer = findObjectByKey(payload?.answers, field.key);
          if (_answer) _ans[field.key] = _answer;
        });
    }
    if (!_ans.locationLongitude || !_ans.locationLatitude) {
      let locationLongitude;
      let locationLatitude;
      try {
        if (!locationLat || !locationLng) {
          const co_ords = await getGeoLocation();
          const { latitude, longitude } = co_ords || {};
          locationLongitude = longitude;
          locationLatitude = latitude;
        } else {
          locationLongitude = locationLng;
          locationLatitude = locationLat;
        }

        // Only attach location if we have some value; it's optional
        if (locationLongitude != null && locationLatitude != null) {
          _ans.locationLongitude = locationLongitude;
          _ans.locationLatitude = locationLatitude;
        }
      } catch (e) {
        console.warn('Failed to obtain geolocation, proceeding without it.', e);
      }
    }
    const verify = await externalVerifySubject({
      sponsorId,
      trialId,
      siteId,
      payload: {
        subjectMasterId: subjectMasterId,
        documentKey: enrolmentDocumentKey,
        documentVersion: '1.0',
        crfDocumentKey: crfDocumentKey,
        crfDocumentVersion: '1.0',
        stepKey: payload.stepKey,
        sectionKey: payload.sectionKey,
        subSectionKey: payload.subSectionKey,
        answers: _ans,
      },
    });
    if (verify.data) {
      dispatch(
        openMessage({
          message: 'Verified Sucessfully!',
          messageSeverity: 'success',
        })
      );
    } else if (
      verify?.error?.data?.message?.includes('External verification is not allowed because there are queries for')
    ) {
      dispatch(
        openMessage({
          message:
            'Verification is not allowed because there are queries for this form that are not in VERIFIED state. Please verify all queries and try again.',
          messageSeverity: 'error',
        })
      );
    } else {
      dispatch(
        openMessage({
          message: 'Verification request failed!',
          messageSeverity: 'error',
        })
      );
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box>
        <Box sx={{ display: 'flex', width: '100%', columnGap: 2 }}>
          <Box sx={{ width: '30%' }}>
            <Box sx={{ paddingY: 2, paddingX: 2, border: '1px solid #E7E7E7' }}>
              <TreeView
                expanded={expandedNodes}
                selected={selectedNodeId}
                onNodeToggle={(event, nodeIds) => {
                  setExpandedNodes(nodeIds);
                }}
                onNodeSelect={onFormSelect}
                defaultCollapseIcon={<MinusSquare />}
                defaultExpandIcon={<PlusSquare />}
                sx={{ overflowX: 'hidden' }}
              >
                {formConfig &&
                  formConfig.steps.map((step) => {
                    const stepSatus = stepStatusData.find((a) => a.stepKey === step.key);
                    const stepConfig = originalFormConfig?.steps?.find((a) => a?.key === step.key);
                    
                    // If step status is Screening_Failure, check if there are any non-pending sections to show
                    if (stepSatus?.status === 'Screening_Failure') {
                      const hasVisibleSections = step.sections.some((section) => {
                        const sectionStatus = stepSatus?.sectionStatuses?.find(
                          (sec) => sec.sectionKey === section.key
                        );
                        return sectionStatus?.status !== 'Pending';
                      });
                      if (!hasVisibleSections) {
                        return null;
                      }
                    }
                    
                    return (
                      ((stepSatus?.status !== 'Pending' && step.showInReadOnly == undefined) || step.showInReadOnly) &&
                      !step.ignoreStatusCheck && (
                        <StyledTreeItem
                          key={`${step.key}`}
                          sx={{
                            '& .MuiTreeItem-content': {
                              paddingY: 1,
                            },
                          }}
                          nodeId={`${step.key}`}
                          label={
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                p: 0.5,
                                pr: 0,
                              }}
                            >
                              <Typography variant="subtitle1" sx={{ fontWeight: 'inherit', flexGrow: 1 }}>
                                <Tooltip title={stepConfig?.lableAbrivation || ''} arrow placement="right">
                                  <span>{step.label}</span>
                                </Tooltip>
                              </Typography>

                              {stepSatus?.status === 'External_Verification_Pending' && (
                                <PendingActionsRoundedIcon
                                  sx={{
                                    color: theme.palette.primary.light,
                                    fontSize: 23,
                                  }}
                                />
                              )}
                            </Box>
                          }
                        >
                          {step &&
                            step.sections.map((section, subIndex) => {
                              const sectionConfig = stepConfig.sections.find((_sec) => _sec.key === section.key);
                              const sectionStatus = stepSatus?.sectionStatuses?.find(
                                (sec) => sec.sectionKey === section.key
                              );
                              
                              // If step status is Screening_Failure, hide sections with Pending status
                              if (stepSatus?.status === 'Screening_Failure' && sectionStatus?.status === 'Pending') {
                                return null;
                              }
                              
                              return (
                                (section.showInReadOnly == undefined || section.showInReadOnly) && (
                                  <StyledTreeItem
                                    key={`${section.key}`}
                                    nodeId={`${section.key}@${step.key}`}
                                    selected={selectedNodeId === `${section.key}@${step.key}`}
                                    label={
                                      <Tooltip title={sectionConfig?.lableAbrivation || ''} arrow placement="right">
                                        <span>{section.label}</span>
                                      </Tooltip>
                                    }
                                  >
                                    {/* {section &&
                                      section.subTabs &&
                                      section.subTabs.map(
                                        (subTab, subIndex1) =>
                                          !SKIPPED_FIELDS_KEY.includes(subTab.key) &&
                                          (subTab.showInReadOnly == undefined || subTab.showInReadOnly) && (
                                            <StyledTreeItem
                                              key={`${subTab.key}`}
                                              nodeId={`${subTab.key}`}
                                              label={subTab.label}
                                            ></StyledTreeItem>
                                          )
                                      )} */}
                                  </StyledTreeItem>
                                )
                              );
                            })}
                        </StyledTreeItem>
                      )
                    );
                  })}
              </TreeView>
            </Box>
          </Box>
          <Box sx={{ width: '70%', paddingX: 1 }}>
            {selectedForm && (
              <FormDetails
                selectedfield={selectedfield}
                setSelectedField={setSelectedField}
                openStepForm={openStepForm}
                details={selectedForm}
                sectionKey={selectedForm.key}
                handleDownload={handleDownloadFile}
                stepKey={selectedStepKey}
                formStatus={selectedFormStatus}
                editAllowed={editAllowed}
                handleDownloadSignature={handleDownloadSignature}
                userSiteTrialRole={userSiteTrialRole}
                answers={subjectDetails}
                readOnlyActions={readOnlyActions}
                verifyAction={handleSubjectVerification}
                subjectName={subjectName}
                formConfig={formConfig}
                queriesByFieldKey={queriesByFieldKey}
                hasOpenQueries={hasOpenQueries}
              />
            )}
            {!selectedForm && (
              <Box sx={{ textAlign: 'center' }}>
                <Typography sx={{ color: 'grey' }}>Please select the form..</Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SubjectDetailCRFInfo;
